var _desc, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "ic-project"
  }, "Project")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--icon-primary)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5001 8.5C12.7292 8.5 13.8334 7.44152 13.8334 6C13.8334 4.55848 12.7292 3.5 11.5001 3.5C10.2709 3.5 9.16675 4.55848 9.16675 6C9.16675 7.44152 10.2709 8.5 11.5001 8.5ZM11.5001 10C13.6172 10 15.3334 8.20914 15.3334 6C15.3334 3.79086 13.6172 2 11.5001 2C9.38299 2 7.66675 3.79086 7.66675 6C7.66675 8.20914 9.38299 10 11.5001 10ZM5.75008 18.5C6.97922 18.5 8.08341 17.4415 8.08341 16C8.08341 14.5585 6.97922 13.5 5.75008 13.5C4.52094 13.5 3.41675 14.5585 3.41675 16C3.41675 17.4415 4.52094 18.5 5.75008 18.5ZM5.75008 20C7.86717 20 9.58341 18.2091 9.58341 16C9.58341 13.7909 7.86717 12 5.75008 12C3.63299 12 1.91675 13.7909 1.91675 16C1.91675 18.2091 3.63299 20 5.75008 20ZM19.5834 16C19.5834 17.4415 18.4792 18.5 17.2501 18.5C16.0209 18.5 14.9167 17.4415 14.9167 16C14.9167 14.5585 16.0209 13.5 17.2501 13.5C18.4792 13.5 19.5834 14.5585 19.5834 16ZM21.0834 16C21.0834 18.2091 19.3672 20 17.2501 20C15.133 20 13.4167 18.2091 13.4167 16C13.4167 13.7909 15.133 12 17.2501 12C19.3672 12 21.0834 13.7909 21.0834 16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProject);
export default __webpack_public_path__ + "static/media/icon-project.24f47ded03977b8daa4fb4b09b710925.svg";
export { ForwardRef as ReactComponent };